import { CalculationStrategy } from "../strategy.class";
export class SingleCalculationStrategy extends CalculationStrategy {
    constructor() {
        super();
    }

    _resolvePrice(variation, customerType) {
        if (customerType === 'contractor' && variation.price.contractor_amount != null) {
            return variation.price.contractor_amount;
        }
        if (variation.price.private_amount != null) {
            return variation.price.private_amount;
        }
        return variation.price.amount;
    }

    calculate(calculationData) {
        const vatMultiplier = calculationData.vatMultiplier || 1.15;

        // Kerb shorts are 330mm (~1/3 m). Quantity is entered in linear meters,
        // so multiply by 3 to get the actual number of pieces needed.
        const isKerbShort = calculationData.type?.id === 'kerbs' && calculationData.variation?.id === 'short';
        const piecesPerLinearMeter = isKerbShort ? 3 : 1;
        const pieceQuantity = calculationData.quantity * piecesPerLinearMeter;

        let price_excl_vat = 0.0;
        let price_incl_vat = 0.0;
        let price_vat = 0.0;
        let palettes = 0;

        if (calculationData.receivingType === "collection") {
            let quantity_mod = Math.floor(pieceQuantity / calculationData.variation.calculation_data.items_per_palette);

            const basePrice = this._resolvePrice(calculationData.variation, calculationData.customerType);
            let price = basePrice;
            if (calculationData.variation.price.type === 'sqm') {
                price = ((basePrice * calculationData.variation.calculation_data.coverage_per_palette) / calculationData.variation.calculation_data.items_per_palette).toFixed(2);
            }

            price_excl_vat = price * pieceQuantity;
            price_incl_vat = price_excl_vat * vatMultiplier;
            price_vat = price_incl_vat - price_excl_vat;

            palettes = quantity_mod;
        } else if (calculationData.receivingType === 'delivery') {
            let quantity_remainder = pieceQuantity % calculationData.variation.calculation_data.items_per_palette;
            let quantity_mod = Math.floor(pieceQuantity / calculationData.variation.calculation_data.items_per_palette);

            if (quantity_remainder > 0) quantity_mod++;

            const basePrice = this._resolvePrice(calculationData.variation, calculationData.customerType);
            let price = basePrice;
            if (calculationData.variation.price.type === 'sqm') {
                price = (basePrice * calculationData.variation.calculation_data.coverage_per_palette) / calculationData.variation.calculation_data.items_per_palette;
            }

            price_excl_vat = price * quantity_mod * calculationData.variation.calculation_data.items_per_palette;
            price_incl_vat = price_excl_vat * vatMultiplier;
            price_vat = price_incl_vat - price_excl_vat;

            palettes = quantity_mod;
        }

        return {
            price_vat,
            price_excl_vat,
            price_incl_vat,
            palettes
        }
    }
}